"use client"

import BookingHeader from './BookingHeader'
import BookingSteps from './BookingSteps'

export default function BookingPageContent() {
  return (
    <div className="min-h-screen bg-white">
      <BookingHeader />
      <BookingSteps />
    </div>
  )
}